<template>
  <div id="magazine" v-if="data && data.content && data.content.length > 0">
    <header-section
      :data="content"
      :logo="data.logo"
      :routeId="routeId"
      :title="data.title"
      :RouteIdHideMenu="RouteIdHideMenu"
      @hideMenu="hideMenu" />

    <div class="magazine_body text-center">
      <div class="border-b pt-3">
        <p class="m-0 text-lg" style="color:#999999" v-if="data.publish_date">{{ data.publish_date }}</p>
        <div style="min-height:36.667px;">
          <h4 v-if="content[selectRouteIdx].unit !== ''" class="mb-0 text-2xl">
            <span :class="{ textshow: isNaN(Number(content[selectRouteIdx].unit)) }">
              Unit
            </span>
            <span>{{ content[selectRouteIdx].unit }}</span>
          </h4>
        </div>
        <div style="min-height:64px;">
          <p v-html="content[selectRouteIdx].nameEn" class="m-0 px-1 text-lg" style="white-space:pre-wrap;"></p>
          <p class="m-0 px-1 text-lg" style="white-space:pre-wrap;">{{ content[selectRouteIdx].name }}</p>
        </div>
      </div>

      <partLesson
        class="main"
        :data="content[selectRouteIdx].sections"
        :routeId="routeId"
        :selectRouteIdx="selectRouteIdx"
        :path="path"
        :closeVideoJs="closeVideoJs"
        :audioCover="posterUrl"
        @toggleAIBtn="toggleAIBtn" />

      <advertisement
        class="container mx-auto max-w-4xl advertisement"
        v-if="adData"
        :adData="adData" />

      <aiButton :aiURL="data.ai_url" :wordCardURL="data.word_card_url" v-if="(data.word_card_url || data.ai_url) && isShowAIBtn" />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import headerSection from '@/components/magazine/headerSection.vue'
import partLesson from '@/components/magazine/PartLesson'
import Api from '@/api'
import advertisement from '@/components/magazine/AdvertiseSwiper.vue'
import { useLangMixin } from '@/components/modules/langMixin'
import aiButton from '@/components/modules/aiButton'
export default {
  name: 'MagazinePage',

  components: {
    headerSection,
    partLesson,
    advertisement,
    aiButton
  },

  setup () {
    const {
      toJap,
      forceToJap,
      rubyParsing,
      jsonDataParsingRuby,
      getOnlyJp,
      checkJPN,
    } = useLangMixin()
    const store = useStore();
    const route = useRoute();
    const path = 'https://storage.liveabc.com/qrcode'
    const data = ref(null);
    const RouteIdHideMenu = ref('');
    const closeVideoJs = ref(false);
    const adData = ref(null);
    const isShowAIBtn = ref(true)

    const getJson = async () => {
      try {
        store.dispatch('isLoading', true)
        const response = await Api.get(`/ebook/${route.params.book}`)
        data.value = response.data;

        data.value.content.forEach(item => {
          item.nameEn = forceToJap(item.nameEn)
        })
        if (response) {
          store.dispatch('isLoading', false)
        }

        if (route.params.id) {
          RouteIdHideMenu.value = 'close';
        } else {
          RouteIdHideMenu.value = '';
        }
      } catch (error) {
        store.dispatch('isLoading', false)
        console.log(error)
      }
    };

    const getAD = async () => {
      try {
        const response = await Api.get('/ad/qrcodeAD')

        adData.value = response.data

      } catch (error) {
        console.error('请求数据失败:', error)
      }
    }
    const posterUrl = computed(() => {
      if (data.value) {
        let magTitle
        switch (data.value.title) {
          case 'CNN互動英語':
            magTitle = 'CNN'
            break
          case '互動日本語':
            magTitle = 'JPN'
            break
          case 'LIVE互動英語':
            magTitle = 'LIVE'
            break
          case 'ALL+互動英語':
            magTitle = 'ALL'
            break
          case 'ABC互動英語':
            magTitle = 'ABC'
            break
          case 'biz互動英語':
            magTitle = 'BIZ'
            break
        }
        const dateStr = data.value.publish_date
        // const dateStr = '2019.08'
        const [year, month] = dateStr.split('.')

        const yearPrefix = year.substring(2)

        // 拼接结果
        const result = yearPrefix + month

        return `https://api.liveabc.com/v1/magazines/${magTitle}_${result}/cover`
      }

      return ''
    });
    const selectRouteIdx = computed(() => {
      const routeId = route.params.id;
      if (routeId) {
        return data.value.content.findIndex(x => x.id === routeId);
      } else {
        return 0;
      }
    });

    const routeId = computed(() => {
      return data.value && data.value.content && data.value.content.length > 0 ? data.value.content[selectRouteIdx.value].id : null;
    });

    const content = computed(() => {
      return data.value ? data.value.content : [];
    });

    const hideMenu = (hideMenu) => {
      closeVideoJs.value = !hideMenu;
    };

    const toggleAIBtn = (toggleAIBtn) => {
      isShowAIBtn.value = toggleAIBtn;
    };

    onMounted(() => {
      getAD()
      getJson()
    })

    return {
      isShowAIBtn,
      path,
      data,
      RouteIdHideMenu,
      closeVideoJs,
      adData,
      selectRouteIdx,
      routeId,
      content,
      hideMenu,
      toJap,
      forceToJap,
      rubyParsing,
      jsonDataParsingRuby,
      getOnlyJp,
      checkJPN,
      toggleAIBtn,
      posterUrl
    };
  }
};
</script>

<style lang="scss" scoped>
  .aiBtn {
    z-index: 101;
    bottom: 0;
    right: 0;
  }
  #magazine {
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    .magazine_body {
      margin-top: 80px;
    }
  }

  p, h4, h5 {
    font-family: 'Arial', Times, serif, '微軟正黑體';
    color: #000;
  }
  .textshow {
    display: none;
  }

  .main {
    position: relative;
  }

  .advertisement {
    margin-bottom: 15em;
  }
</style>
